import React, { useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import styled from 'styled-components';
import AddressContext from '../../../context/address/addressContext';

const StyledBurger = styled.div`
  input[type='email'],
  input[type='text'],
  select {
    padding: 3px 1rem;
    color: #fff;
    background: none;
    outline: none;
    border-radius: 0.8rem;
    box-shadow: none;
    border: 1px solid #fff;
  }
  input[type='email']:focus,
  input[type='text']:focus {
    // background: #000;
    outline: none;
    box-shadow: none;
  }
  .fa-trash:hover {
    cursor: pointer;
  }
  .bold-style {
    font-size: 1rem;
    font-weight: bold;
  }
`;

const AddressCard = ({ address }) => {
  const addressContext = useContext(AddressContext);

  const { deleteAddress } = addressContext;

  const {
    id,
    firstname,
    lastname,
    number,
    addressAdd,
    city,
    state,
    pincode,
  } = address;

  const onDelete = () => {
    deleteAddress(id);
  };
  return (
    <StyledBurger>
      <Row>
        <Col md={10} className='d-flex'>
          <div className='py-1'>
            <label className='cust_check-box'>
              <div className='bold-style'>
                {firstname} {lastname}
              </div>
              <div className=' mr-5 '>
                {addressAdd} {city}
                {', '}
                {state}
                {' - '}
                {pincode}
              </div>
              <div className='mt-3'>Mobile number - {number}</div>
              <input type='checkbox' name='check' />
              <span className='checkmark'></span>
            </label>
          </div>
        </Col>
        <Col className='d-flex pl-0'>
          <div className='ml-4'>
            <i className='fa fa-address-card text-light' aria-hidden='true'></i>
          </div>
          <div className='ml-auto'>
            <i
              className='fa fa-trash text-light'
              aria-hidden='true'
              onClick={onDelete}
            ></i>
          </div>
        </Col>
      </Row>
      <div className='divider-white'></div>
    </StyledBurger>
  );
};
export default AddressCard;
